/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first column names the rows and the header row names the columns.`)
};

const es_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La primera columna nombra las filas y la fila de cabecera nombra las columnas.`)
};

const de_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die erste Spalte benennt die Zeilen, und die Kopfzeile benennt die Spalten.`)
};

const nl_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De eerste kolom benoemt de rijen en de headerrij benoemt de kolommen.`)
};

const fr_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La première colonne nomme les lignes et la ligne d'en-tête nomme les colonnes.`)
};

const it_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La prima colonna nomina le righe e la riga di intestazione nomina le colonne.`)
};

const pt_br2_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira coluna nomeia as linhas e a linha de cabeçalho nomeia as colunas.`)
};

const pt_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira coluna nomeia as linhas e a linha de cabeçalho nomeia as colunas.`)
};

const ja_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の列が行名を、ヘッダー行が列名を指定します。`)
};

const zh_heat_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第一列命名行，表头行命名列。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_ex3", locale)
	if (locale === "en") return en_heat_ex3(inputs)
	if (locale === "es") return es_heat_ex3(inputs)
	if (locale === "de") return de_heat_ex3(inputs)
	if (locale === "nl") return nl_heat_ex3(inputs)
	if (locale === "fr") return fr_heat_ex3(inputs)
	if (locale === "it") return it_heat_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_heat_ex3(inputs)
	if (locale === "pt") return pt_heat_ex3(inputs)
	if (locale === "ja") return ja_heat_ex3(inputs)
	return zh_heat_ex3(inputs)
};